import {
    GET_EVENTS_FAILED,
    GET_EVENTS_LOADING,
    GET_EVENTS_SUCCESS
} from '../constants'
import axios from 'axios'

export function getEvents() {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(getEventsLoading(true))
            axios.get(`${process.env.BASE_URL}/events/upcoming?orgId=2`).then((response) => {
                dispatch(getEventsSuccess(response))
                resolve(response)
            }).catch(err => dispatch(getEventsFailed(err)))
        })
    }
}

export const getEventsLoading = (bool) => ({ type: GET_EVENTS_LOADING, bool })
export const getEventsSuccess = (result) => ({ type: GET_EVENTS_SUCCESS, result })
export const getEventsFailed = (msg) => ({ type: GET_EVENTS_FAILED, msg })